import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useNavigationBar } from "../../context/NavigationContext";
import CreateChannelProvider, { CreateChannelContext } from "../../context/CreateChannelContext";
import ContainerNavigation from "../../components/ContainerNavigation";
import { useAuth } from "../../context/AuthContext";
import { useContext, useEffect, useState } from "react";
import { ChannelState, ChannelSubstate, getChannelEditStatusString, getChannelStatusString } from "../../models/SKChannel";
import { CreateArtifactContext } from "../../context/CreateArtifactContext";

{
  /* <Layout navProps={{backArrow: false, title: '', filterOption: false, nextAction: '', onBack: () => {}, onFilter: () => {}, onNext: () => {}}} /> */
}

interface CreateChannelLayoutProps {
  children?: React.ReactNode;
}

const CreateChannelContextLayout = ({ children }: CreateChannelLayoutProps) => {
  const navContext = useNavigationBar();
  const location = useLocation();

  const [hideStatus, setHideStatus] = useState(false);
  useEffect(() => {
    if (location.pathname.includes("/onboarding")) {
      setHideStatus(true);
    }
  }, [location]);

  const {
    backArrow,
    title,
    subtitle,
    userActions,
    buttonTitle,
    enableLink,
    filterOption,
    onActionItemSelect,
    getActionItems,
    onBack,
    onClose,
    onFilter,
    onNext,
    onEdit,
  } = navContext.navProps;

  return (
    // <CreateChannelProvider isEdit={isEdit}>
    <div>
      <ContainerNavigation
        backArrow={backArrow}
        title={title}
        subtitle={subtitle}
        userActions={userActions}
        enableLink={enableLink}
        buttonTitle={buttonTitle}
        filterOption={filterOption}
        onBack={onBack}
        onFilter={onFilter}
        onNext={onNext}
        onClose={onClose}
        onEdit={onEdit}
        onActionItemSelect={onActionItemSelect}
        getActionItems={getActionItems}
      />

      <div className="left-0 flex flex-col w-full h-[calc(100vh-200px)] overflow-y-auto top-[84px] ">
        {!hideStatus ? <ChannelStatus /> : <></>}
        <Outlet />
      </div>
    </div>
    // </CreateChannelProvider>
  );
};

const ChannelStatus = () => {
  const { channelData, originalState } = useContext(CreateChannelContext);

  return (
    <>
      <div className="flex items-center gap-5 justify-end mt-[5px] mr-3">
        {channelData?.followerCount ? (
          <div className="flex items-center gap-1">
            <span className="capitalize edit-status-top  !text-sm !font-normal">{channelData.followerCount}</span>
            <span className="">followers</span>
          </div>
        ) : (
          <></>
        )}
        <div className="flex items-center gap-1">
          <p className="ml-1 capitalize">
            {originalState
              ? getChannelEditStatusString(originalState?.subStatus)
              : getChannelStatusString(channelData.status, channelData.subStatus, false)}
          </p>
          {channelData.status === ChannelState.ACTIVE && (
            <span>
              <img src={"/icons/CheckItem.png"} className="object-contain w-[14px] h-[14px] min-w-5" alt="Certification status" />
            </span>
          )}
        </div>
      </div>
    </>
  );
};

const ChannelStatus2 = () => {
  const { channelData, originalState } = useContext(CreateChannelContext);

  return (
    <>
      {channelData && (
        <div className={`flex items-center justify-end p-[3px] pr-3  `}>
          <div className="flex items-center gap-1">
            <p className="capitalize edit-status-top">{getChannelStatusString(channelData?.status, channelData.subStatus)}</p>
            {channelData?.status === ChannelState.ACTIVE && (
              <span>
                <img src={"/icons/CheckItem.png"} className="object-contain w-[14px] h-[14px] min-w-5" alt="Certification status" />
              </span>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default CreateChannelContextLayout;
